'use es6';

import { omit } from 'underscore';
import ImmutableModel from 'DesignData/models/ImmutableModel';
import * as smartObjectHelper from 'DesignData/helpers/smartObjectHelper';
/**
 * Wrapper class of Global Widget data.
 * Intended for reflection and helper methods.
 */

export default class GlobalWidget extends ImmutableModel {
  /**
   * @constructor
   */
  constructor(rawProps) {
    // smart content properties should be saved in "body" and snake-cased
    const props = omit(rawProps, ['definitionId', 'smartObjects', 'smartType', 'smartTypeId']);
    return super(props);
  }

  getSmartProperties() {
    return smartObjectHelper.getSmartProperties(this.body);
  }

  getTargetType() {
    return smartObjectHelper.getTargetType(this.type);
  }

  getTargetContentType() {
    return smartObjectHelper.getTargetContentType(this.type);
  }

  getTargetedContent() {
    return smartObjectHelper.getTargetedContent(this.type, this.body);
  }

}